import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { actions as formActions } from 'react-redux-form';
import { FormattedText } from 'core/i18n';
import UtagHelper from 'utilities/utagHelper';
import { PATH_JOINHOLDER_ACCESS } from 'constants/uTagConstants/paths';
import { JointLogin } from 'components/jointHolders/JointLogin';
import cryptoJS from 'crypto-js';
import { recordAndSavePage } from 'actions/errorViewNavigation';

class Decision extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            animateClassName: false,
            showLoginForm: false,
        };

        this.handleNoClient = this.handleNoClient.bind(this);
    }

    UNSAFE_componentWillMount() {
        setTimeout(() => {
            this.setState({
                animateClassName: !this.state.animateClassName,
            });
        }, 0);
    }

    componentDidMount() {
        const { userProfile, products, recordAndSavePage } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';

        const invite = userProfile.jointHolderData ? userProfile.jointHolderData.invite : null;
        if (invite) {
            const JointHolderInfo = UtagHelper.getJointHolderInfoFromInvite(invite);
            recordAndSavePage(
                PATH_JOINHOLDER_ACCESS,
                '',
                '',
                userProfile.product,
                products.get('productsDescription'),
                invite.promoCode,
                JointHolderInfo,
                '',
                '',
                userProfile.investmentType,
                {
                    identificadorOnboarding: docNumberEncrypted,
                }
            );
        }
    }

    handleNoClient() {
        const { formActions } = this.props;

        this.setState({
            animateClassName: !this.state.animateClassName,
        });

        setTimeout(() => {
            formActions.change('userProfile.isJointHolderNoClient', true);
        }, 500);
    }

    handleClickShowLogin = () => {
        this.setState({ showLoginForm: !this.state.showLoginForm });
    };

    render() {
        const { animateClassName } = this.state;
        const decisionClassName = classNames('joint-holder-decision-container animation-fade', {
            'animation-fade--show': animateClassName,
            'animation-fade--hide': !animateClassName,
        });

        return (
            <div className={decisionClassName}>
                <h3>
                    <FormattedText value="initial-jointHolderDecisionQuestion" />
                </h3>
                <div className="form">
                    <button className="form__button form__button-primary" type="button" onClick={this.handleNoClient}>
                        <FormattedText value="button-notCustomer" />
                    </button>
                    <button
                        className="form__button form__button-primary"
                        type="button"
                        onClick={this.handleClickShowLogin}
                    >
                        <FormattedText value="button-customer" />
                    </button>
                </div>
                <div>
                    <JointLogin show={this.state.showLoginForm} onClose={this.handleClickShowLogin} />
                </div>
            </div>
        );
    }
}

module.exports.constructor = Decision;
module.exports.Decision = connect(
    state => ({
        userProfile: state.userProfile,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(Decision);
